"use client";

import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { BlockInheritRow } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { useIsSemDiscoverPage } from "@faire/retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { MaybeRenderSEMTextBlock } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageMaybeRenderSEMTextBlock/SearchPageMaybeRenderSEMTextBlock";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";
import styled from "styled-components";

export const SearchOrDiscoverPageBelowFooter = () => {
  return (
    <>
      <MaybeRenderSEMTextBlock />
      <SearchPageBelowFooter />
    </>
  );
};

export const SearchPageBelowFooter = () => {
  const isSemDiscoverPage = useIsSemDiscoverPage();

  if (isSemDiscoverPage) {
    return null;
  }

  return (
    <WhenVisibilityIsImminent customizePlaceholder={<FaireFooterPlaceholder />}>
      <FaireFooter />
    </WhenVisibilityIsImminent>
  );
};

const FaireFooterPlaceholder = styled.div`
  height: 400px;
  width: 100%;
`;

const FaireFooter = () => {
  return (
    <BlockInheritRow>
      <RetailerFooter hideReferral />
    </BlockInheritRow>
  );
};
